<template>
  <span
    v-if="shouldRender"
    v-tooltip="tooltip"
    data-testid="account-table-header-badge"
    class="tw-ms-4 sf-label sf-label-primary"
  >
    {{ label }}</span
  >
</template>

<script setup lang="ts">
import { useCommon } from '../store/common'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { accounts, recommendations } = storeToRefs(useCommon())

const tooltip = computed(() => {
  if (allAccountsHaveExternalMapping.value) {
    if (hasAIProposals.value) {
      return window.I18n.t(
        'account_mapping_list.externally_and_ai_mapped.tooltip'
      )
    } else {
      return window.I18n.t('account_mapping_list.all_externally_mapped.tooltip')
    }
  }
  return ''
})

const label = computed(() => {
  if (allAccountsHaveExternalMapping.value) {
    if (hasAIProposals.value) {
      return window.I18n.t(
        'account_mapping_list.externally_and_ai_mapped.label'
      )
    } else {
      return window.I18n.t('account_mapping_list.all_externally_mapped.label')
    }
  }
  return ''
})

const allAccountsHaveExternalMapping = computed(() => {
  return Object.keys(accounts.value).every((accountId) => {
    return accounts.value[accountId].externallyMappedNumber
  })
})

const hasAIProposals = computed(() => {
  return Object.keys(recommendations.value).length > 0
})

const shouldRender = computed(() => {
  return label.value.length > 0
})
</script>
